export default {
  text: '{{threshold}} Monatsumsatz: {{amount}}',
  label: '{{threshold}} Monatsumsatz:',
  no_discount: 'kein Rabatt',
  discount_badge: '-{{percentage}}%',
};
